<template>
  <v-row class="quiz-pagination mx-1">
    <v-btn
      v-if="currentSection!=1"
      @click="$emit('update:section', -1)"
      class="float-left"
      color="primary"
    >
        <v-icon left>mdi-chevron-left</v-icon>
      Prev
    </v-btn>
    <v-spacer></v-spacer>
    <div v-if="currentSection === totalSectionCount" class="text-center">
      <v-dialog
        v-model="dialog"
        width="500"
      >
        <template v-slot:activator="{ on, attrs }">
            <div class="d-flex flex-column align-end">
            <v-btn
              v-if="currentSection === totalSectionCount"
              v-bind="attrs"
              v-on="on"          
              color="primary"
              :disabled="!isAllQuestionsAnswered">
              Submit
                <v-icon right>mdi-check</v-icon>
            </v-btn>
            <div class="text-caption mt-5" v-if="!isAllQuestionsAnswered">
                <v-chip color="amber" text-color="secondary" small>
                    {{numQuestionsUnanswered}} Questions Left
                </v-chip>
            </div>
            </div>
        </template>

        <v-card>
          <v-card-title>
            Submit answers?
          </v-card-title>

          <v-card-text>
            After you submit your answers, you can't go back to change them.
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialog = false"
            >
              Go Back
            </v-btn>
            <v-btn
              color="primary"
              text
              @click="submitQuiz"
              :disabled="!isAllQuestionsAnswered || loading"
              :loading="loading"
            >
              Submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <v-btn
      v-else
      @click="$emit('update:section', 1)"
      class="float-right"
      color="primary"
    >
      Next
        <v-icon right>
        mdi-chevron-right
        </v-icon>
    </v-btn>
  </v-row>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    currentSection: Number,
    totalSectionCount: Number
  },
  computed: {
    ...mapState(['numQuestionsAnswered', 'numQuestions', 'selectedOptions']),

    isAllQuestionsAnswered() {
      return this.numQuestionsAnswered == this.numQuestions
    },
    numQuestionsUnanswered() {
      return this.numQuestions - this.numQuestionsAnswered
    }
  },
  data() {
    return {
      dialog: false,
      loading: false
    }
  },
  methods:{
      async submitQuiz(){
        this.loading = true
        try {
          var answers = [];

          for (var option in this.selectedOptions) {
            var answer = {question_id: Number(option)}

            let selection = this.selectedOptions[option]

            // Check if single choice answer
            if (typeof selection == "number") {
              answer.answer_id = selection;
            }
            // Check if multiple choice answer
            else {
              answer.answer_ids = selection;
            }

            answers.push(answer);
          }

          // Determine if correct or not
          const results = await this.$store.dispatch('updateQuiz', {answers})
          const data = results.data;

          this.$store.commit('UPDATE_QUIZ_FINISHED', true);
          this.$store.commit('UPDATE_QUIZ_PASSED', data.passed);

          if (data.passed) {
            this.$store.commit('UPDATE_RETURN_URL', data.return_url)
          }
          else {
            this.$store.commit('UPDATE_WRONG_ANSWERS_COUNT', data.wrong_answers_count )
          }
          // Go to submissions page
          this.$router.push({name: 'completePage'})
        } finally {
          this.loading = false
        }
      }
  },
}
</script>

<style>

</style>